import { useEffect, useState } from 'react'
import { getRequestId } from './api'
import { usePlace } from 'commons/usePlace'
import { isNil } from 'ramda'

export function useAIRequestId(id) {
  const [requestId, setRequestId] = useState()
  const place = usePlace()

  useEffect(() => {
    if (requestId) return

    async function run() {
      if (isNil(id)) {
        if (place.enabledAi) {
          const { request_id } = await getRequestId()
          setRequestId(request_id)
        }
      } else {
        setRequestId(id)
      }
    }
    run()
  }, [requestId, setRequestId])

  return requestId
}
